import { WHATSAPP_PATH } from '../techIcons';

export interface ContactNumber {
  country: string;
  /** Display form. */
  label: string;
  /** Digits only, for tel: and wa.me links. */
  digits: string;
}

export const NUMBERS: ContactNumber[] = [
  { country: 'PK', label: '+92 332 5429482', digits: '923325429482' },
  { country: 'US', label: '+1 603 999 7348', digits: '16039997348' },
];

export function WhatsAppMark({ size = 15 }: { size?: number }): React.JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      aria-hidden="true"
      focusable="false"
    >
      <path d={WHATSAPP_PATH} fill="currentColor" />
    </svg>
  );
}

/** Number rows with a call link and a WhatsApp link for each. */
export function ContactNumbers({ variant }: { variant: 'footer' | 'aside' }): React.JSX.Element {
  return (
    <ul className={`numbers numbers-${variant}`}>
      {NUMBERS.map((n) => (
        <li key={n.digits}>
          <a className="num-call" href={`tel:+${n.digits}`}>
            <span className="cc">{n.country}</span>
            {n.label}
          </a>
          <a
            className="num-wa"
            href={`https://wa.me/${n.digits}`}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Message the ${n.country} number on WhatsApp`}
          >
            <WhatsAppMark />
            <span>WhatsApp</span>
          </a>
        </li>
      ))}
    </ul>
  );
}
